// goddessRadarChart.js

async function renderGoddessRadarChart(container, scores, showNegative = true, quizKey = 'archetype_quiz') {
  const goddessImages = {
    Aphrodite: "https://cdn.shopify.com/s/files/1/0709/1722/6741/files/aphrodite_64624c09-1a60-439d-b85a-a2876c5d4150.png?v=1749824087",
    Athena: "https://cdn.shopify.com/s/files/1/0709/1722/6741/files/athena.png?v=1749824086",
    Artemis: "https://cdn.shopify.com/s/files/1/0709/1722/6741/files/artemis.png?v=1749824087",
    Demeter: "https://cdn.shopify.com/s/files/1/0709/1722/6741/files/demeter_29f45f4a-c2df-4050-a4a0-4cc79978fdac.png?v=1749824087",
    Hera: "https://cdn.shopify.com/s/files/1/0709/1722/6741/files/hera.png?v=1749824086",
    Hestia: "https://cdn.shopify.com/s/files/1/0709/1722/6741/files/hestia.png?v=1749824087",
    Persephone: "https://cdn.shopify.com/s/files/1/0709/1722/6741/files/persephone.png?v=1749824087"
  };

  const labels = Object.keys(scores);
  const pos = labels.map(k => scores[k].positive);
  const neg = labels.map(k => scores[k].negative);

  const maxPos = Math.max(...pos);
  const maxNeg = Math.max(...neg);
  const dynamicMax = Math.max(maxPos, maxNeg);

  function getResponsiveImageSize() {
    const width = window.innerWidth;
    return width < 768 ? 70 : 128;
  }

  function getResponsiveFontSize() {
    const width = window.innerWidth;
    return width < 768 ? 11 : 14;
  }

  const imageSize = getResponsiveImageSize();
  const fontSize = getResponsiveFontSize();

  // Determine label based on quiz type
  let positiveLabel = "Positive Traits";
  if (quizKey === 'love_quiz') {
    positiveLabel = "Love Traits";
  } else if (quizKey === 'career_quiz') {
    positiveLabel = "Career Traits";
  }

  function createGradient(ctx, chartArea, colorStops) {
    const gradient = ctx.createLinearGradient(0, 0, 0, chartArea.bottom);
    colorStops.forEach(stop => gradient.addColorStop(stop.offset, stop.color));
    return gradient;
  }

  const datasets = [
    {
      label: positiveLabel,
      data: pos,
      legendColor:"rgba(205, 150, 75, 0.85)",
      backgroundColor: function(context) {
        const chart = context.chart;
        const chartArea = chart.chartArea;
        const canvasCtx = chart.ctx;

        if (!chartArea) return 'rgba(0,0,0,0)'; // fallback 透明色

        return createGradient(ctx, chartArea, [
          { offset: 0, color: 'rgba(205, 150, 75, 0.85)' },
          { offset: 0.7, color: 'rgba(240, 220, 180, 0.5)' },
          { offset: 1, color: 'rgba(255, 245, 230, 0.25)' }
        ]);
      },
      borderColor: 'transparent',
      borderWidth: 5,
      pointBackgroundColor: 'rgba(225, 200, 95, 0.9)',
      pointRadius: 4,
      pointHoverRadius: 10,
      tension: 0.3,
      fill: true,
    }
  ];

  if (showNegative) {
    datasets.push({
      label: "Shadow Traits",
      data: neg,
      legendColor:"rgba(70, 40, 20, 0.8)",
      backgroundColor: function(context) {
        const chart = context.chart;
        const chartArea = chart.chartArea;
        const canvasCtx = chart.ctx;

        if (!chartArea) return 'rgba(0,0,0,0)'; // fallback 透明色

        return createGradient(canvasCtx, chartArea, [
          { offset: 0, color: 'rgba(70, 40, 20, 0.8)' },
          { offset: 0.6, color: 'rgba(135, 90, 60, 0.45)' },
          { offset: 1, color: 'rgba(230, 210, 180, 0.2)' }
        ]);
      },
      borderColor: 'transparent',
      borderWidth: 5,
      pointBackgroundColor: '#AE8469',
      pointRadius: 4,
      pointHoverRadius: 12,
      tension: 0.3,
      fill: true,
    });
  }

  const goddessIcons = {};
  const preloadImages = imageMap => Promise.all(
    Object.entries(imageMap).map(([label, url]) => new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => { goddessIcons[label] = img; resolve(); };
      img.onerror = reject;
      img.src = url;
    }))
  );

  await preloadImages(goddessImages);

  // 注销旧插件（如果存在）
  Chart.unregister('goddessImagePlugin');

  // 重新注册插件，在 afterDraw 中动态计算 imageSize
  Chart.register({
    id: 'goddessImagePlugin',
    afterDraw(chart) {
      const {ctx, chartArea} = chart;
      // 动态计算当前的图片大小
      const currentImageSize = getResponsiveImageSize();
      const centerX = chartArea.left + (chartArea.right - chartArea.left) / 2;
      const centerY = chartArea.top + (chartArea.bottom - chartArea.top) / 2;
      const radius = chart.scales.r.drawingArea + currentImageSize/2 + 10;
      chart.data.labels.forEach((label, i) => {
        const angle = (Math.PI * 2 / chart.data.labels.length) * i - Math.PI / 2;
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);
        const img = goddessIcons[label];
        if (img?.complete) {
          ctx.drawImage(img, x - currentImageSize / 2, y - currentImageSize / 2, currentImageSize, currentImageSize);
        }
      });
    }
  });

  // 动态插入 canvas
  container.innerHTML = `<canvas id="goddessRadarChart" height="300"></canvas>`;
  const ctx = document.getElementById("goddessRadarChart").getContext("2d");

  new Chart(ctx, {
    type: "radar",
    plugins: [ChartDataLabels],
    data: {
      labels: labels.map(l => l.charAt(0).toUpperCase() + l.slice(1)),
      datasets
    },
    options: {
      responsive: true,
      elements: { line: { tension: 0.3 } },
      layout: {
        padding: {
          top: imageSize + 10, bottom: 0, left: 0, right: 0
        },
      },
      scales: {
        r: {
          suggestedMin: 0,
          suggestedMax: dynamicMax,
          angleLines: { color: "#cbb7a1" },
          grid: { color: "#d7c5b0" },
          ticks: { display: false },
          pointLabels: { display: false }
        }
      },
      plugins: {
        legend: {
          position: 'bottom',
          title: {
            display: true,
            text: '',
            padding: {
              bottom: fontSize < 12 ? imageSize - 8 : imageSize - 20
            }
          },
          labels: {
            color: "#222222",
            font: { size: fontSize, family: "Georgia, serif" },
            padding: fontSize < 12 ? 8 : 15,
            boxWidth: fontSize < 12 ? 30 : 40,
            generateLabels: chart => chart.data.datasets.map((ds, i) => ({
              text: ds.label,
              fillStyle: ds.legendColor || ds.backgroundColor,
              strokeStyle: 'transparent',
              lineWidth: 0,
              index: i,
              hidden: !chart.isDatasetVisible(i),
              datasetIndex: i
            }))
          }
        },
        tooltip: {
          callbacks: {
            label: ctx => `${ctx.dataset.label}: ${ctx.formattedValue}`
          }
        },
        datalabels: {
          display: false,
          color: () => '#ffffff',
          font: { weight: 'bold', size: 12, family: 'Georgia, serif' },
          formatter: v => v
        }
      }
    }
  });
}
